import React, { useState, useEffect, Fragment } from "react"
import { useCallback } from 'react';
import {
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
  List,
  Edit,
  Datagrid,
  TextField,
  Pagination,
  Create,
  ReferenceField,
  ReferenceManyField,
  DateField,
  DateInput,
  EditButton,
  FormTab,
  TabbedForm,
  BooleanInput,
  NumberField,
  Tab,
  Button,
  Link,
  FunctionField,
  LongTextInput,
  Toolbar,
  SaveButton,
  SimpleForm,
  FormDataConsumer
} from "react-admin";

import { isEmpty, prop, isNil } from "ramda";
import { parse } from "query-string";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import { CustomInputFilter } from "../components/selectboxfilter/custominputfilter";
import Timelapse from "@material-ui/icons/Timelapse";
import Visibility from "@material-ui/icons/Visibility";
import PermIdentity from "@material-ui/icons/PermIdentity";
import moment from "moment";
import { getPermissionRole } from "../util";

let miga =JSON.parse(localStorage.getItem('url_miga'));
const VehiclePagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const status = [
  { _id: "A", description: "Active" },
  { _id: "V", description: "Sale" },
  { _id: "X", description: "Retired" }
];

const AddNewMaintenanceButton = object => (
  <Button
    component={Link}
    to={{
      pathname: "/maintenances/create",
      search: `?vehicle_id=${object.record.id}`
    }}
    label="Add maintenance"
    style={{ padding: "15px" }}
  >
    <ChatBubbleIcon />
  </Button>
);

const validateForm = values => {
  const errors = {};
  if (!values.licence_plate) {
    errors.licence_plate = ["Licence Plate is required"];
  }
  if (!values.vehicle_color) {
    errors.vehicle_color = ["Color is required"];
  }
  if (!values.vehicle_model_id) {
    errors.vehicle_model_id = ["Vehicle model is required"];
  }
  if (!values.purchased_from) {
    errors.purchased_from = ["Purchased from is required"];
  }
  if (!values.purchase_date) {
    errors.purchase_date = ["Purchased date is required"];
  }
  
  // Validaciones para vehículos de renting
  if (values.renting === true) {
    if (!values.retirement_date) {
      errors.retirement_date = ["Retirement date is required for rental vehicles"];
    }
    
    // Validar que retirement_date no sea menor que purchase_date
    if (values.retirement_date && values.purchase_date) {
      const retirementDate = moment(values.retirement_date);
      const purchaseDate = moment(values.purchase_date);
      
      if (retirementDate.isBefore(purchaseDate)) {
        errors.retirement_date = ["Retirement date cannot be before purchase date"];
      }
    }
  }

  return errors;
};

const VehicleToolbar = (props) => { 
  const url_miga = JSON.parse(localStorage.getItem('url_miga'));
  let link = (url_miga == '/undefined') ? '/vehicles' : url_miga 

 /*  const handleSave = (redirect) => {
    props.props.redirect(redirect);
  };

  if (props.saving != false){
    handleSave(link)
  } */

  return (
    <Toolbar {...props}>
      <Button
        component={Link}
        to={{
          pathname: link,
        }}
        label={
          `${link}` === "/vehicles"
            ? "Back to vehicles"
            : "Back to Current fleet"
        }
      >
        <ArrowBackIcon />
      </Button>
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
        <SaveButton redirect={link}/>
      )}
    </Toolbar>
  );
};


const EditDamageButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `/vehicle_damages/${object.record.id}`,
        search: `?vehicle_id=${object.record.vehicle_id}`
      }}
      label="Damage"
    >
      <Visibility />
    </Button>
  );
};

const ViewRentalLink = object => {
  const link = `/${
    object.record.rental.type === 1 ? "tour_clients" : "rental_clients"
  }/${object.record.rental_id}/show`;
  return (
    <Button
      component={Link}
      to={{
        pathname: link
      }}
      label="Rental"
    >
      <Timelapse />
    </Button>
  );
};

const ViewClientLink = object => {
  const link = `/clients/${object.record.client_id}`;
  return (
    <Button
      component={Link}
      to={{
        pathname: link
      }}
      label="Client"
    >
      <PermIdentity />
    </Button>
  );
};

const VehicleFilter = props => (
  <Filter {...props}>
    <TextInput label="Licence Plate" source="licence_plate" alwaysOn />
    <TextInput label="Vechicle Chassis" source="vechicle_chassis" alwaysOn />
    <CustomInputFilter label="Vehicle Model" source="vechicle_model" alwaysOn />
    <SelectInput
      allowEmpty={false}
      label="Status"
      source="vehicle_status"
      choices={status}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
  </Filter>
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/history/${props.record.id}`
    }}
    label="Vehicle History"
  >
    <ChatBubbleIcon />
  </Button>
);

const CustomEditButton = object => {
  localStorage.setItem('url_miga', JSON.stringify("/vehicles"));
  const link = `/vehicles/${object.record.id}`;
  return (
    <EditButton
      to={{
        pathname: link,
        state: { status: object.record.status != undefined ? object.record.status.vehicle_status : 0 }
        // search: `?s=${object.record.status.vehicle_status}`
      }}
      label="Edit"
    />
  );
};

const SwitchButton = props => {
  const rentals = props.record.rentals || [];

    if ([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) {
   
    return   (  <EditButton
    basePath="vehicle_switch_activity"
    record={props.record}
    label="Switch Activity"
  />);
    }
    else{
      return "";
    }
    
};

export const VehicleList = props => {

  return (
    <List
      {...props}
      resource="vehicles"
      pagination={<VehiclePagination />}
      filters={<VehicleFilter />}
      bulkActionButtons={false}
      filter={{ show_rentals: true }}
      filterDefaultValues={{ vehicle_status: "A" }}
    >
      <Datagrid>
        <ReferenceField
          label="Model"
          source="vehicle_model_id"
          reference="vehicle_models"
          linkType={false}
        >
          <TextField source="model_name" />
        </ReferenceField>
        <TextField label="Vechicle Color" source="vehicle_color" />
        {/* <TextField label="Licence Plate" source="licence_plate" /> */}
        <FunctionField addLabel={true}
            label="Licence Plate"
            render={item => {
              if (item.renting) {
                return `${item.licence_plate} ®`;
              }
              else{
                return `${item.licence_plate}`;
              }
            }}
          />
        <TextField
          label="Vehicle Mileage (Km)"
          source="vehicle_mileage"
          defaultValue="0"
        />
        <ReferenceField
          label="Vehicle Status"
          source="vehicle_status_id"
          reference="vehicle_statuses"
          linkType={false}
        >
          <FunctionField
            addLabel={false}
            render={item => {
              if (item.vehicle_status === "A") {
                return "Active";
              }
              if (item.vehicle_status === "V") {
                return "Sale";
              }
              if (item.vehicle_status === "X") {
                return "Retired";
              }
            }}
          />
        </ReferenceField>
        <CustomEditButton /> 
        {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
          <SwitchButton />            
        )}
        <HistoryButton />
      </Datagrid>
    </List>    
  )
  
};

const VehicleTitle = object => (
  <span>
    {" Edit "} &quot;{object.record.licence_plate}&quot; {object.record.renting ? "®" : ""}
  </span>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

function formatDate(date) {
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}


let isRenting = 0

export const VehicleEdit = ({ permissions, ...props }) => {
  const from = parse(props.location.search).from;
  let link = !isNil(from) ? `/${from}` : "/vehicles";
  const p = props
  const redirect = p.location.state
  //let link = '/vehicles'
  if (redirect != null) {
    link = `/${redirect.miga}`
    miga = link 
  } 

  // Hook para inicializar automáticamente la fecha de retiro en vehículos de renting
  useEffect(() => {
    if (props.record && props.record.renting && props.record.purchase_date && !props.record.retirement_date) {
      // Si es renting, tiene purchase_date pero no retirement_date, calcular automáticamente
      const retirementDate = moment(props.record.purchase_date).add(8, 'months').format('YYYY-MM-DD');
      // Aquí podrías usar un callback para actualizar el formulario si es necesario
      console.log('Auto-calculated retirement date:', retirementDate);
    }
  }, [props.record]);

  return (
    <Edit title={<VehicleTitle />} {...props} redirect={{link}}>
      <TabbedForm syncWithLocation={false}
        toolbar={<VehicleToolbar props={{ ...props }} redirect={{link}} />}
        validate={validateForm}
        redirect={link}
      >
        <FormTab label="General" props={{ ...props }} redirect={{link}}>
          <ReferenceField
            label="Model"
            source="vehicle_model_id"
            reference="vehicle_models"
            allowEmpty
            linkType={false}
          >
            <TextField source="model_name" />
          </ReferenceField>
          <TextInput label="Licence Plate" source="licence_plate" />
          <TextInput label="Color" source="vehicle_color" />
          <TextInput
            label="Mileage"
            source="vehicle_mileage"
            defaultValue={0}
          />
          <TextInput label="Chassis" source="vechicle_chassis" />
          <FunctionField
            label="Buy Type"
            render={bike => {
              if (bike.rental) {
                return "Rental";
              } else if (bike.financing > 0) {
                return "Financing";
              } else {
                return "Cash";
              }
            }}
          />
          <LongTextInput label="Options" source="vehicle_options" />

          <FunctionField
            label="Retirement Date"
            addLabel={false}
            props={{ ...props }}
            style={{width:'100%'}}
            render={bike => {  
              if (bike.renting == true){
                return ( 
                  <DateInput 
                    props={{ ...props }} 
                    style={{width:'25%'}} 
                    label="Retirement Date" 
                    source="retirement_date" 
                    locales="es-Es" 
                    options={{ 
                      timeZone: 'UTC',
                      minDate: bike.purchase_date || undefined
                    }} 
                    format={formatDate}
                    validate={[
                      (value) => {
                        if (bike.renting && value && bike.purchase_date) {
                          const retirementDate = moment(value);
                          const purchaseDate = moment(bike.purchase_date);
                          if (retirementDate.isBefore(purchaseDate)) {
                            return 'Retirement date cannot be before purchase date';
                          }
                        }
                        return undefined;
                      }
                    ]}
                  />
                )
              } 
              else{
                return ''
              }
          }}
          />
          {status === "X" && <DateField label="Sale Date" source="sale_date" />}
          {status === "X" && (
            <ReferenceField
              label="Sold to"
              source="sold_to"
              reference="locations"
            >
              <TextField source="location_name" />
            </ReferenceField>
          )}
          {status === "X" && (
            <NumberField
              label="Sale Price"
              source="sale_price"
              options={{ style: "currency", currency: "EUR" }}
            />
          )}
          {status === "X" && (
            <FunctionField
              label="Invoice Url (Draft)"
              render={bike => {
                if (bike.express_invoice_url) {
                  return (
                    <a target="_blank" href={bike.express_invoice_url}>
                      Invoice (Draft) - {bike.express_invoice_id}{" "}
                    </a>
                  );
                } else {
                  return <p />;
                }
              }}
            />
          )}
          <HistoryButton />
        </FormTab>

        {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
          <FormTab label="Financial Data" props={{ ...props }} redirect={{link}} >
            <TextInput label="Financing" source="financing" />
            <TextInput label="Financing details" source="financing_details" />
            <DateInput label="Purchase date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
            <TextInput label="Purchase price" source="purchase_price" />
            <ReferenceInput
              label="Purchased from"
              source="purchased_from"
              reference="locations"
              filter={{ only_sellers: "true", only_suppliers: "true" }}
              sort={{ field: "location_name", order: "ASC" }}
            >
              <SelectInput source="id" optionText="location_name" />
            </ReferenceInput>
            <BooleanInput label="Rental" source="renting" />
            <BooleanInput label="Low" source="low" />
          </FormTab>
        )}
        {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && (
          <FormTab label="Insurance Data" props={{ ...props }} redirect={{link}} >
            <DateInput label="Insurance Date" source="insurance_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
            <ReferenceInput
              label="Insurance Status"
              source="insurance_status_id"
              reference="insurance_statuses"
              sort={{ field: "insurance_status", order: "ASC" }}
            >
              <SelectInput source="id" optionText="insurance_status" />
            </ReferenceInput>
            <TextInput label="Insurance Policy" source="insurance_policy" />
          </FormTab>            
        )}
        <FormTab label="Maintenances" props={{ ...props }} redirect={{link}} >
          <Tab label="Vehicle Maintenances" path="maintenances">
            <ReferenceManyField
              addLabel={false}
              reference="maintenances"
              target="vehicle_id"
              sort={{ field: "maintenance_date", order: "DESC" }}
            >
              <Datagrid>
                <TextField source="id" label="Maintenance Id" />
                <DateField source="maintenance_date" />
                <TextField source="maintenance_kms" />
                <FunctionField
                  label="Done"
                  render={item => {
                    if (item.done) {
                      return "Yes";
                    }
                    return "No";
                  }}
                />
                <ReferenceField
                  label="Maintenance Item"
                  source="maintenance_item_id"
                  reference="maintenance_items"
                  linkType={false}
                >
                  <TextField source="description" />
                </ReferenceField>
                <ReferenceField
                  label="Maintenance Item Type"
                  source="maintenance_item_id"
                  reference="maintenance_items"
                  linkType={false}
                >
                  <ReferenceField
                    source="maintenance_item_type_id"
                    reference="maintenance_item_types"
                    linkType={false}
                  >
                    <TextField source="description" />
                  </ReferenceField>
                </ReferenceField>
                <NumberField
                  source="total_price"
                  options={{ style: "currency", currency: "EUR" }}
                />
                {([1, 2, 3, 4, 5, 6, 7, 9].includes(getPermissionRole())) && ( 
                  <EditButton />
                )}
              </Datagrid>
            </ReferenceManyField>
            {([1, 2, 3, 4, 5, 6, 7, 9].includes(getPermissionRole())) && ( 
              <AddNewMaintenanceButton />
            )}
          </Tab>
        </FormTab>
        <FormTab label="Damages" props={{ ...props }} redirect={{link}} >
          <Tab label="Damages" path="vehicle_damages">
            <ReferenceManyField
              addLabel={false}
              reference="vehicle_damages"
              target="vehicle_id"
              sort={{ field: "damage_date", order: "DESC" }}
            >
              <Datagrid>
                <TextField source="id" />
                <DateField source="damage_date" />
                <NumberField
                  source="cost"
                  options={{ style: "currency", currency: "EUR" }}
                  label="Cost"
                />
                <NumberField
                  source="ammount_charged"
                  options={{ style: "currency", currency: "EUR" }}
                  label="Charged"
                />
                <TextField source="km" label="KM" />
                <TextField source="comment" label="Comment" />
                <ViewRentalLink />
                <ViewClientLink />
                <EditDamageButton />
              </Datagrid>
            </ReferenceManyField>
            {/* <AddNewDamageButton /> */}
          </Tab>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

const SetRenting = () => {
  console.log('%cvehicles.js line:494 dat', 'color: #007acc;', rentingState);
  return ( <span> Is renting: true</span> )
}

let rentingState = false
export const VehicleCreate = ({ permissions, ...props }) => {
  const p = props
  const redirect = p.location.state
  let link = '/vehicles'
  if (redirect != null) {
    link = `/${redirect.miga}`
  }
  miga = link 

  const [state, setState] = useState({
    renting: false,
    purchase_date: null,
    retirement_date: null
  });
  
  const handleRentingChange = e => {
    rentingState = e.target.checked
    SetRenting()
    
    const newState = {
      ...state,
      renting: rentingState,
    };
    
    // Si se marca como renting y ya hay fecha de compra, calcular automáticamente la fecha de retiro
    if (rentingState && state.purchase_date) {
      const retirementDate = moment(state.purchase_date).add(8, 'months').format('YYYY-MM-DD');
      newState.retirement_date = retirementDate;
    }
    
    setState(newState);
  }

  const handlePurchaseDateChange = (date) => {
    // Actualizar el estado local para tracking
    setState({
      ...state,
      purchase_date: date
    });
  }

  return (
  <Create title="Create" {...props}>
    <SimpleForm
      validate={validateForm}
      toolbar={<VehicleToolbar props={{ ...props }} 
      redirect />}
      redirect={link}
    >
      <ReferenceInput
        label="Model"
        source="vehicle_model_id"
        reference="vehicle_models"
        perPage={999}
        sort={{ field: "order", order: "ASC" }}
        filter={{ active: "true", type: 2 }}
        allowEmpty
      >
        <SelectInput source="id" optionText="model_name" />
      </ReferenceInput>
      <TextInput label="Licence Plate" source="licence_plate" />
      <TextInput label="Color" source="vehicle_color" />
      <TextInput label="Mileage" source="vehicle_mileage" defaultValue={0} />
      <TextInput label="Chassis" source="vechicle_chassis" />
      <ReferenceInput
        label="Purchased from"
        source="purchased_from"
        reference="locations"
        filter={{ only_sellers: "true", only_suppliers: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <DateInput 
        label="Purchase date" 
        source="purchase_date" 
        locales="es-Es" 
        options={{ timeZone: 'UTC' }}
        onChange={handlePurchaseDateChange}
      />
      <LongTextInput label="Options" source="vehicle_options" />
      <BooleanInput label="Rental" onChange={handleRentingChange} source="renting" />
      {rentingState === true && (
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <DateInput 
              label="Retirement date" 
              source="retirement_date" 
              locales="es-Es" 
              options={{ 
                timeZone: 'UTC',
                minDate: formData.purchase_date || undefined
              }}
              defaultValue={formData.purchase_date ? moment(formData.purchase_date).add(8, 'months').format('YYYY-MM-DD') : undefined}
              validate={[
                (value) => {
                  if (rentingState && value && formData.purchase_date) {
                    const retirementDate = moment(value);
                    const purchaseDate = moment(formData.purchase_date);
                    if (retirementDate.isBefore(purchaseDate)) {
                      return 'Retirement date cannot be before purchase date';
                    }
                  }
                  return undefined;
                }
              ]}
              {...rest}
            />
          )}
        </FormDataConsumer>
      )}
      <BooleanInput label="Low" source="low" />
    </SimpleForm>
  </Create>
)};



// WEBPACK FOOTER //
// ./src/resources/vehicles.js